import {FC} from 'react'

import {Alert, AlertVariant} from '@/components/common/alerts/Alert'
import {useMobile} from '@/components/context/MobileProvider'
import {useCommonContent} from '@/content/common'
import {Trans} from '@/i18n'
import {theme} from '@/theme/theme'
import {formatDate} from '@/utils/formatDate'
import {useLanguage} from '@/utils/i18n/language'
import {IpOfficePriceIncreaseAlertType} from '@/utils/registration-request/types'

type IpOfficePriceIncreaseAlertProps = IpOfficePriceIncreaseAlertType & {
  handleClose?: () => void
}

export const IpOfficePriceIncreaseAlert: FC<IpOfficePriceIncreaseAlertProps> = ({
  date,
  ipOffice,
  linkHref,
  handleClose,
}) => {
  const language = useLanguage()
  const {ipOfficePriceIncreaseDescription} = useCommonContent()
  const isMobile = useMobile()

  return (
    <>
      <Alert
        handleClose={handleClose}
        isCloseable={isMobile}
        variant={AlertVariant.info}
        description={
          <Trans
            i18nKey={ipOfficePriceIncreaseDescription}
            values={{
              date: formatDate(date.toISO(), language, false, 'd LLLL yyyy'),
              ipOffice,
            }}
          >
            text
            <a className="link underline" href={linkHref} target="_blank" rel="noreferrer">
              link
            </a>
          </Trans>
        }
      />

      <style jsx>{`
        .link {
          color: ${theme.palette.info.main};
        }
      `}</style>
    </>
  )
}
